/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartRunningAggregateAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M2 2h6v6H2zm2 2v2h2V4zm5-2h6v6H9zm2 2v2h2V4zm5-2h6v6h-6zm2 2v2h2V4zM2 9h6v6H2zm2 2v2h2v-2zm7 9h11v2H9V9h2v7.646l2.338-2.4L17.667 11H22v2h-3.667l-3.67 2.753L11 19.512zm-9-4h6v6H2zm2 2v2h2v-2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgChartRunningAggregateAlt as ChartRunningAggregateAlt };
